<template>
  <a-modal
      :title="title"
      :visible="visible"
      @ok="ok"
      @cancel="cancel"
      width="660px"
    >
      <a-space slot="footer">
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" :loading="btnLoading" @click="ok">确定</a-button>
      </a-space>
      <div class="distributionTitle">
        <p>NHF配销差说明：</p>
        <p>· 配销差 = 净销价格 - 包材价格 - 配方优化成本 / 投入产出比</p>
        <p>· 配方优化成本、净销价格、包材价格、配方优化成本发生变化，将重新计算配销差</p>
      </div>
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" class="formErr">
        <a-form-item label="投入产出比">
          <div style="display: flex;padding-top: 10px;">
            <a-input-number class="addonBefore" v-decorator="['inputOutputRatio', { rules: [{ required: true, message: '请输入投入产出比' }] }]" :precision="1" :min="0" :max="100" />
            <a-button disabled class="addonAfter">%</a-button>
          </div>
        </a-form-item>
        <a-form-item label="净销价格">
          <div style="display: flex;padding-top: 10px;">
            <a-input-number class="addonBefore" v-decorator="['netSellingPrice', { rules: [{ required: true, message: '请输入净销价格' }] }]" :precision="1" :min="0" :max="999999999999.9" />
            <a-button disabled class="addonAfter">元/吨</a-button>
          </div>
        </a-form-item>
        <a-form-item label="包材价格">
          <div style="display: flex;padding-top: 10px;">
            <a-input-number class="addonBefore" v-decorator="['packageMaterialPrice', { rules: [{ required: true, message: '请输入包材价格' }] }]" :precision="1" :min="0" :max="999999999999.9" />
            <a-button disabled class="addonAfter">元/吨</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
</template>

<script>
export default {
  components: {},
  props: ['hide','detail','formulaId'],
  data() {
    return {
      title: '编辑配销差',
      form: this.$form.createForm(this),
      btnLoading: false,
    }
  },
  watch: {
    visible(val){
      if(val) this.init()
    },
  },
  computed: {
    visible: {
      get(){
        return this.hide
      },
      set(){}
    }
  },
  created() {},
  mounted() {},
  methods: {
    init(){
      let {inputOutputRatio,netSellingPrice,packageMaterialPrice} = this.detail || {}
      setTimeout(() => {
        this.form.setFieldsValue({inputOutputRatio,netSellingPrice,packageMaterialPrice})
      }, 0);
    },
    ok(){
      this.form.validateFields((err,values) => {
        if(!err){
          let data = {
            ...this.detail,
            ...values,
            formulaId: this.formulaId,
          }
          this.btnLoading = true
          this.$post('/nhf-app/formuladistributiondiff/updateOrAddCalFormulaDistributionDiff',data).then(res => {
            if(res.success) {
              this.$emit('close',true)
              this.btnLoading = false
            }
          })
        }
      })
    },
    cancel(){
      this.$emit('close')
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped>
.distributionTitle{
  background: rgba(245, 245, 245, 1);
  color: rgba(0,0,0,.3);
  padding: 5px 50px;
  box-shadow: 0 2px 5px 3px rgba(0,0,0,.1);
  margin-bottom: 30px;
  p{
    margin-bottom: 3px;
  }
}
.addonBefore{
  width: calc(100% - 55px);
  border-radius: 4px 0 0 4px;
}
.addonAfter{
  border-left: none;
  border-radius: 0 4px 4px 0;
  height: 25px;
}
</style>